(() => {
  const PER_KEER = 24;
  const IMG = 'https://cdn.rebrickable.com/media/sets/';

  const maak = (tag, attrs, ...kinderen) => {
    const el = document.createElement(tag);
    for (const [k, v] of Object.entries(attrs || {})) {
      if (v == null || v === false) continue;
      if (k === 'tekst') el.textContent = v;
      else if (k.startsWith('on')) el.addEventListener(k.slice(2), v);
      else el.setAttribute(k, v === true ? '' : v);
    }
    for (const k of kinderen) if (k != null && k !== '') el.append(k);
    return el;
  };

  const normaal = (s) => String(s).toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const kaalNr = (nr) => (nr.endsWith('-1') ? nr.slice(0, -2) : nr);
  const taal = document.documentElement.lang || 'nl';
  const euro = (p) => '€ ' + Number(p).toLocaleString(taal, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  const meld = (naam, data) => {
    const stuur = () => { try { window.Shopify.analytics.publish('spg_zoekset_' + naam, data || {}); } catch (_) {} };
    if (window.Shopify?.analytics?.publish) stuur(); else window.addEventListener('load', stuur, { once: true });
  };
  const zetBron = () => {
    try { fetch('/cart/update.js', { method: 'POST', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { _bron: 'zoek-een-set' } }) }).catch(() => {}); } catch (_) {}
  };

  const start = (root) => {
    if (root.dataset.klaar) return;
    root.dataset.klaar = '1';
    const veld = root.querySelector('[data-spg-zs-veld]');
    const status = root.querySelector('[data-spg-zs-status]');
    const lijst = root.querySelector('[data-spg-zs-lijst]');
    const meer = root.querySelector('[data-spg-zs-meer]');
    const setVeld = root.querySelector('[data-spg-zs-set]');
    const onderwerp = root.querySelector('[data-spg-zs-onderwerp]');
    const zoekUrl = (root.dataset.zoek || ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + 'search/suggest') + '.json';
    let T = {};
    try { T = JSON.parse(root.querySelector('[data-spg-zs-teksten]').textContent); } catch (_) {}
    for (const k of Object.keys(T)) T[k] = new DOMParser().parseFromString(String(T[k]), 'text/html').documentElement.textContent;
    const tk = (k, v) => String(T[k] || '').replace('%n', () => (v && v.n != null ? v.n : '')).replace('%q', () => (v && v.q != null ? v.q : ''));

    let sets = null;
    let treffers = [];
    let getoond = 0;
    let vraagNr = 0;
    const winkelCache = new Map();
    const wachtrij = [];
    let bezig = 0;

    const laden = fetch(root.dataset.sets)
      .then((r) => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then((d) => {
        sets = d.s.map((s) => ({ nr: s[0], kaal: kaalNr(s[0]), naam: s[1], jaar: s[2], thema: d.t[s[3]] || '', stenen: s[4], beeld: s[5] === 1, zoek: normaal(s[1] + ' ' + (d.t[s[3]] || '')) }));
      })
      .catch(() => { status.textContent = tk('setlijst_fout'); });

    const winkelZoek = (q, aantal) => {
      const u = new URL(zoekUrl, location.origin);
      u.searchParams.set('q', q);
      u.searchParams.set('resources[type]', 'product');
      u.searchParams.set('resources[limit]', String(aantal));
      u.searchParams.set('resources[options][unavailable_products]', 'last');
      return fetch(u, { headers: { Accept: 'application/json' } })
        .then((r) => (r.ok ? r.json() : null))
        .then((d) => (d && d.resources && d.resources.results && d.resources.results.products) || [])
        .catch(() => []);
    };

    const nrUitTitel = (p) => {
      const m = String(p.handle || '').match(/-(\d{3,7})$/) || String(p.title || '').match(/(?:^|\D)(\d{4,7})\s*$/);
      return m ? m[1] : null;
    };

    const volgende = () => {
      while (bezig < 2 && wachtrij.length) {
        const { kaal, klaar } = wachtrij.shift();
        bezig++;
        winkelZoek(kaal, 6).then((ps) => {
          const p = ps.find((x) => nrUitTitel(x) === kaal) || null;
          winkelCache.set(kaal, p);
          klaar(p);
        }).finally(() => { bezig--; volgende(); });
      }
    };

    const inWinkel = (kaal) => new Promise((klaar) => {
      if (winkelCache.has(kaal)) return klaar(winkelCache.get(kaal));
      wachtrij.push({ kaal, klaar });
      volgende();
    });

    const naarAanvraag = (s) => {
      meld('marco', { set: s.kaal });
      setVeld.value = s.kaal + (s.naam ? ' ' + s.naam : '');
      onderwerp.value = 'Zoek een set: ' + s.kaal;
      const vak = setVeld.closest('.spg-zs__vak');
      vak.classList.add('spg-zs__vak--uitgelicht');
      vak.querySelector('.spg-zs__thumb')?.remove();
      vak.classList.remove('spg-zs__vak--thumb');
      if (s.beeld) {
        const thumb = maak('img', { class: 'spg-zs__thumb', src: IMG + encodeURIComponent(s.nr.toLowerCase()) + '.jpg', alt: '', width: '40', height: '40', decoding: 'async' });
        thumb.addEventListener('error', () => { thumb.remove(); vak.classList.remove('spg-zs__vak--thumb'); }, { once: true });
        vak.append(thumb);
        vak.classList.add('spg-zs__vak--thumb');
      }
      document.getElementById('spg-zs-aanvraag').scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      setTimeout(() => root.querySelector('input[name="contact[email]"]').focus({ preventScroll: true }), 450);
    };

    const vulWinkel = (vak, s, p) => {
      const zoekKnop = maak('button', { type: 'button', class: 'spg-zs-knop spg-zs-knop--licht', onclick: () => naarAanvraag(s) }, tk('laat_marco_zoeken'));
      if (p && p.available) {
        vak.replaceChildren(
          maak('p', { class: 'spg-zs-kaart__stand spg-zs-kaart__stand--ja' }, maak('span', { tekst: tk('op_voorraad_bij') }), maak('span', { class: 'spg-zs-kaart__prijs', tekst: euro(p.price) })),
          maak('div', { class: 'spg-zs-kaart__knoppen' }, maak('a', { class: 'spg-zs-knop spg-zs-knop--groen', href: p.url.split('?')[0], tekst: tk('bekijk_en_bestel'), onclick: () => { meld('bestel', { set: s.kaal }); zetBron(); } })));
      } else if (p) {
        vak.replaceChildren(
          maak('p', { class: 'spg-zs-kaart__stand spg-zs-kaart__stand--op', tekst: tk('nu_uitverkocht') }),
          maak('div', { class: 'spg-zs-kaart__knoppen' }, zoekKnop, maak('a', { class: 'spg-zs-knop spg-zs-knop--licht', href: p.url.split('?')[0], tekst: tk('bekijk'), onclick: () => meld('bekijk', { set: s.kaal }) })));
      } else {
        vak.replaceChildren(
          maak('p', { class: 'spg-zs-kaart__stand', tekst: tk('niet_op_voorraad') }),
          maak('div', { class: 'spg-zs-kaart__knoppen' }, zoekKnop));
      }
    };

    const kijker = 'IntersectionObserver' in window ? new IntersectionObserver((items) => {
      for (const it of items) {
        if (!it.isIntersecting) continue;
        kijker.unobserve(it.target);
        const k = it.target;
        const s = k._set;
        inWinkel(s.kaal).then((p) => {
          vulWinkel(k.querySelector('.spg-zs-kaart__winkel'), s, p);
          if (p && p.title) k.querySelector('.spg-zs-kaart__nl').textContent = p.title.replace(/\s*-\s*\d{3,7}\s*$/, '');
        });
      }
    }, { rootMargin: '200px 0px' }) : null;

    const kaart = (s) => {
      const beeld = maak('div', { class: 'spg-zs-kaart__beeld', 'data-nr': s.kaal });
      if (s.beeld) {
        const img = maak('img', { src: IMG + encodeURIComponent(s.nr.toLowerCase()) + '.jpg', alt: 'LEGO ' + s.naam + ' (' + s.kaal + ')', loading: 'lazy', decoding: 'async', width: '400', height: '300' });
        img.addEventListener('error', () => { img.remove(); beeld.classList.add('spg-zs-kaart__beeld--leeg'); }, { once: true });
        beeld.append(img);
      } else beeld.classList.add('spg-zs-kaart__beeld--leeg');
      beeld.append(maak('span', { class: 'spg-zs-kaart__labels' }, maak('span', { class: 'spg-zs-kaart__nr', tekst: s.kaal }), maak('span', { class: 'spg-zs-kaart__jaar', tekst: String(s.jaar) })));
      const steen = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      steen.setAttribute('viewBox', '0 0 32 32');
      steen.setAttribute('aria-hidden', 'true');
      steen.innerHTML = '<rect x="4" y="12" width="24" height="14" rx="2"/><rect x="8" y="7" width="6" height="5" rx="1.5"/><rect x="18" y="7" width="6" height="5" rx="1.5"/>';
      const chips = maak('div', { class: 'spg-zs-kaart__chips' },
        s.thema ? maak('span', { class: 'spg-zs-chip spg-zs-chip--thema', tekst: s.thema }) : null,
        maak('span', { class: 'spg-zs-chip' }, steen, tk('stukjes', { n: s.stenen.toLocaleString(taal) })));
      const k = maak('li', { class: 'spg-zs-kaart' },
        beeld,
        maak('div', { class: 'spg-zs-kaart__tekst' },
          maak('h3', { class: 'spg-zs-kaart__naam', tekst: s.naam }),
          maak('p', { class: 'spg-zs-kaart__nl' }),
          chips,
          maak('div', { class: 'spg-zs-kaart__winkel' }, maak('p', { class: 'spg-zs-kaart__stand spg-zs-kaart__stand--laden', tekst: tk('even_kijken') }))));
      k._set = s;
      if (kijker) kijker.observe(k);
      else inWinkel(s.kaal).then((p) => vulWinkel(k.querySelector('.spg-zs-kaart__winkel'), s, p));
      return k;
    };

    const toon = () => {
      const stuk = treffers.slice(getoond, getoond + PER_KEER);
      lijst.append(...stuk.map(kaart));
      getoond += stuk.length;
      meer.hidden = getoond >= treffers.length;
    };

    const zoek = (q) => {
      const nq = normaal(q);
      if (!nq) return [];
      if (/^\d[\d ]*$/.test(nq) && nq.replace(/ /g, '').length >= 2) {
        const n = nq.replace(/ /g, '');
        return sets
          .filter((s) => s.kaal.startsWith(n))
          .sort((a, b) => (b.kaal === n) - (a.kaal === n) || a.kaal.length - b.kaal.length || b.jaar - a.jaar);
      }
      const woorden = nq.split(' ').filter((w) => w.length > 1 || /\d/.test(w));
      if (!woorden.length) return [];
      const uit = [];
      for (const s of sets) {
        const hooi = s.zoek + ' ' + s.kaal + ' ' + s.jaar;
        if (!woorden.every((w) => hooi.includes(w))) continue;
        const naam = normaal(s.naam);
        const score = (naam === nq ? 4 : 0) + (naam.startsWith(nq) ? 2 : 0) + (woorden.every((w) => (' ' + naam).includes(' ' + w)) ? 1 : 0);
        uit.push([score, s]);
      }
      return uit.sort((a, b) => b[0] - a[0] || b[1].jaar - a[1].jaar).map((x) => x[1]);
    };

    const telTekst = (n, q) => (n === 1 ? tk('gevonden_een', { q }) : tk('gevonden_meer', { n, q }));

    let meetKlok;
    let gemeten = '';
    let viaLink = false;
    const meetZoek = (q, mijn) => {
      clearTimeout(meetKlok);
      meetKlok = setTimeout(() => {
        const vraag = q.trim().slice(0, 40);
        if (mijn !== vraagNr || !vraag || vraag === gemeten || /@|\d{8,}/.test(vraag)) return;
        gemeten = vraag;
        const data = { q: vraag.toLowerCase(), treffers: treffers.length, via: viaLink ? 'link' : 'typen' };
        viaLink = false;
        if (!treffers.length) return meld('zoek', { ...data, voorraad: 'geen set' });
        inWinkel(treffers[0].kaal).then((p) => meld('zoek', { ...data, set: treffers[0].kaal, voorraad: p ? (p.available ? 'ja' : 'uitverkocht') : 'nee' }));
      }, 1500);
    };

    const voerUit = async (q) => {
      const mijn = ++vraagNr;
      meetZoek(q, mijn);
      const u = new URL(location.href);
      if (q.trim()) u.searchParams.set('q', q.trim()); else u.searchParams.delete('q');
      history.replaceState(history.state, '', u);
      lijst.replaceChildren();
      meer.hidden = true;
      getoond = 0;
      if (!q.trim()) { status.textContent = ''; treffers = []; return; }
      if (!sets) {
        status.textContent = tk('sets_laden');
        await laden;
        if (mijn !== vraagNr || !sets) return;
      }
      treffers = zoek(q);
      const tekstVraag = !/^\s*\d[\d\s-]*$/.test(q) && normaal(q).length >= 3;
      status.textContent = treffers.length ? telTekst(treffers.length, q.trim()) : (tekstVraag ? tk('kijken_winkel') : tk('geen_nummer', { q: q.trim() }));
      toon();
      if (!tekstVraag) return;
      const ps = await winkelZoek(q.trim(), 8);
      if (mijn !== vraagNr) return;
      const extra = [];
      const al = new Set(treffers.slice(0, getoond).map((s) => s.kaal));
      for (const p of ps) {
        const nr = nrUitTitel(p);
        if (!nr || al.has(nr)) continue;
        winkelCache.set(nr, p);
        const s = sets.find((x) => x.kaal === nr);
        if (s) { extra.push(s); al.add(nr); }
      }
      if (extra.length) {
        treffers = extra.concat(treffers.filter((s) => !extra.includes(s)));
        lijst.replaceChildren();
        getoond = 0;
        toon();
      }
      status.textContent = treffers.length ? telTekst(treffers.length, q.trim()) : tk('geen_naam', { q: q.trim() });
    };

    let wacht;
    veld.addEventListener('input', () => { clearTimeout(wacht); wacht = setTimeout(() => voerUit(veld.value), 180); });
    veld.addEventListener('keydown', (e) => { if (e.key === 'Enter') { e.preventDefault(); clearTimeout(wacht); voerUit(veld.value); veld.blur(); } });
    meer.addEventListener('click', toon);
    root.querySelectorAll('[data-spg-zs-voorbeeld]').forEach((b) => b.addEventListener('click', () => { veld.value = b.dataset.spgZsVoorbeeld; voerUit(veld.value); }));
    setVeld.addEventListener('input', () => {
      onderwerp.value = 'Zoek een set: ' + setVeld.value.trim().slice(0, 60);
      setVeld.closest('.spg-zs__vak').querySelector('.spg-zs__thumb')?.remove();
      setVeld.closest('.spg-zs__vak').classList.remove('spg-zs__vak--thumb');
    });

    const form = setVeld.form;
    const nbVink = root.querySelector('[data-spg-zs-nieuwsbrief]');
    const nbForm = root.querySelector('[data-spg-zs-nb-form]');
    let nbKlaar = false;
    form.addEventListener('submit', (e) => {
      if (nbKlaar || !nbVink || !nbVink.checked || !nbForm || !form.checkValidity()) return;
      e.preventDefault();
      nbForm.querySelector('input[name="contact[email]"]').value = form.querySelector('input[name="contact[email]"]').value;
      const stop = new AbortController();
      const klok = setTimeout(() => stop.abort(), 5000);
      fetch(nbForm.action, { method: 'POST', body: new FormData(nbForm), credentials: 'same-origin', signal: stop.signal })
        .catch(() => {})
        .finally(() => { clearTimeout(klok); nbKlaar = true; form.requestSubmit ? form.requestSubmit() : form.submit(); });
    });

    const melding = root.querySelector('[data-spg-zs-melding]');
    if (melding) {
      if (melding.classList.contains('spg-zs__melding--ok')) meld('aanvraag');
      melding.scrollIntoView({ block: 'center' });
      melding.focus({ preventScroll: true });
    }

    const beginQ = new URL(location.href).searchParams.get('q');
    if (beginQ) { veld.value = beginQ; viaLink = true; voerUit(beginQ); }
  };

  const alles = () => document.querySelectorAll('[data-spg-zs]').forEach(start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', alles); else alles();
  document.addEventListener('shopify:section:load', alles);
})();
